module.exports = __webpack_public_path__ + "img/org-unit.c87f9ec2.svg";